/**
 * Vitality Greens theme — global behavior.
 * Vanilla JS only: no external libraries or CDNs are loaded. Mobile nav,
 * search, cart drawer (via Shopify's Section Rendering API + Ajax Cart API),
 * tabs, accordions and the testimonial carousel are all implemented here.
 */
document.documentElement.classList.remove('no-js');

/* ----------------------------- Mobile nav ------------------------------ */
(function () {
  var toggles = document.querySelectorAll('[data-mobile-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  var overlay = document.querySelector('[data-mobile-nav-overlay]');
  if (!nav || !overlay) return;

  function open() {
    nav.hidden = false;
    overlay.hidden = false;
    requestAnimationFrame(function () {
      nav.classList.add('is-open');
      overlay.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
  }

  function close() {
    nav.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { nav.hidden = true; overlay.hidden = true; }, 220);
  }

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      nav.classList.contains('is-open') ? close() : open();
    });
  });
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();

/* -------------------------------- Search -------------------------------- */
(function () {
  var toggles = document.querySelectorAll('[data-search-toggle]');
  var drawer = document.querySelector('[data-search-drawer]');
  if (!drawer) return;

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var isHidden = drawer.hidden;
      if (isHidden) {
        drawer.hidden = false;
        var input = drawer.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      } else {
        drawer.hidden = true;
      }
    });
  });
})();

/* ------------------------------ Cart drawer ------------------------------ */
var CartDrawer = (function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-drawer-overlay]');
  var openTriggers = document.querySelectorAll('[data-cart-drawer-toggle]');
  var closeTriggers = document.querySelectorAll('[data-cart-drawer-close]');

  function refreshDrawerMarkup() {
    var url = window.location.pathname + window.location.search;
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return fetch(url + sep + 'sections=cart-drawer')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newDrawer = temp.querySelector('[data-cart-drawer]');
        var newOverlay = temp.querySelector('[data-cart-drawer-overlay]');
        if (newDrawer && drawer) {
          var wasOpen = drawer.classList.contains('is-open');
          drawer.innerHTML = newDrawer.innerHTML;
          if (wasOpen) drawer.classList.add('is-open');
          drawer.hidden = false;
          bindDrawerEvents();
        }
        if (newOverlay && overlay) {
          // overlay itself has no dynamic content, nothing to sync
        }
      })
      .catch(function (err) { console.error('Cart drawer refresh failed', err); });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-hidden', count === 0);
    });
  }

  function open() {
    if (!drawer) return;
    drawer.hidden = false;
    overlay.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; overlay.hidden = true; }, 220);
  }

  function bindDrawerEvents() {
    if (!drawer) return;
    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
  }

  function changeLineItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return cart;
      })
      .catch(function (err) { console.error('Cart update failed', err); });
  }

  if (overlay) overlay.addEventListener('click', close);
  openTriggers.forEach(function (t) {
    t.addEventListener('click', function (e) {
      if (t.tagName === 'A') e.preventDefault();
      open();
    });
  });
  closeTriggers.forEach(function (t) { t.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  bindDrawerEvents();

  return {
    open: open,
    close: close,
    refresh: refreshDrawerMarkup,
    updateCartCount: updateCartCount,
    changeLineItem: changeLineItem
  };
})();

/* --------------------- Cart quantity / remove (delegated) ---------------------
   Works for both the cart drawer and the standalone /cart page. */
document.addEventListener('click', function (e) {
  var qtyBtn = e.target.closest('[data-quantity-change]');
  var removeBtn = e.target.closest('[data-cart-remove]');
  var trigger = qtyBtn || removeBtn;
  if (!trigger) return;

  var isInDrawer = !!trigger.closest('[data-cart-drawer]');
  var key = trigger.getAttribute('data-key');
  var newQty = 0;

  if (qtyBtn) {
    var delta = parseInt(qtyBtn.getAttribute('data-quantity-change'), 10);
    var valueEl = qtyBtn.closest('.quantity-stepper').querySelector('[data-quantity-value]');
    newQty = Math.max(0, parseInt(valueEl.textContent, 10) + delta);
  }

  trigger.disabled = true;
  CartDrawer.changeLineItem(key, newQty).then(function () {
    if (isInDrawer) {
      CartDrawer.refresh();
    } else {
      window.location.reload();
    }
  });
});

/* -------------------------- Add to cart (AJAX) --------------------------- */
document.addEventListener('submit', function (e) {
  var form = e.target.closest('form[data-product-form]');
  if (!form) return;
  e.preventDefault();

  var submitBtn = form.querySelector('[type="submit"]');
  var errorEl = form.querySelector('[data-form-error]');
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.classList.add('is-loading');
  }
  if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

  var formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: formData
  })
    .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
    .then(function (result) {
      if (!result.ok) {
        throw new Error(result.data.description || 'Unable to add item to cart');
      }
      return fetch('/cart.js').then(function (res) { return res.json(); });
    })
    .then(function (cart) {
      CartDrawer.updateCartCount(cart.item_count);
      if (window.themeSettings && window.themeSettings.cartType === 'page') {
        window.location.href = window.themeRoutes.cart_url;
        return;
      }
      CartDrawer.refresh().then(CartDrawer.open);
    })
    .catch(function (err) {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = err.message;
      }
    })
    .finally(function () {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
      }
    });
});

/* --------------------------------- Tabs ---------------------------------- */
document.querySelectorAll('[data-tabs]').forEach(function (tabGroup) {
  var triggers = tabGroup.querySelectorAll('[data-tab-trigger]');
  var panels = tabGroup.querySelectorAll('[data-tab-panel]');

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var target = trigger.getAttribute('data-tab-trigger');

      triggers.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
      trigger.classList.add('is-active');
      trigger.setAttribute('aria-selected', 'true');

      panels.forEach(function (panel) {
        var match = panel.getAttribute('data-tab-panel') === target;
        panel.hidden = !match;
      });
    });
  });
});

/* ------------------------------- Carousel -------------------------------- */
document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
  var track = carousel.querySelector('[data-carousel-track]');
  var prevBtn = carousel.querySelector('[data-carousel-prev]');
  var nextBtn = carousel.querySelector('[data-carousel-next]');
  var dots = carousel.querySelectorAll('[data-carousel-dot]');
  if (!track) return;

  function cardStep() {
    var card = track.querySelector('[data-carousel-item]');
    var gap = 20;
    return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
  }

  function scrollByCard(direction) {
    track.scrollBy({ left: cardStep() * direction, behavior: 'smooth' });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var index = parseInt(dot.getAttribute('data-carousel-dot'), 10);
      track.scrollTo({ left: index * cardStep(), behavior: 'smooth' });
    });
  });

  function updateControls() {
    if (prevBtn && nextBtn) {
      var maxScroll = track.scrollWidth - track.clientWidth - 4;
      prevBtn.disabled = track.scrollLeft <= 4;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }
    if (dots.length) {
      var activeIndex = Math.round(track.scrollLeft / cardStep());
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeIndex);
      });
    }
  }
  track.addEventListener('scroll', updateControls, { passive: true });
  window.addEventListener('resize', updateControls);
  updateControls();
});

/* ------------------------------- Quantity --------------------------------
   Generic quantity stepper used on product & cart pages (outside the drawer) */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-quantity-input-change]');
  if (!btn) return;
  var wrapper = btn.closest('[data-quantity-stepper]');
  var input = wrapper.querySelector('input[type="number"]');
  var delta = parseInt(btn.getAttribute('data-quantity-input-change'), 10);
  var min = parseInt(input.getAttribute('min') || '0', 10);
  var newVal = Math.max(min, (parseInt(input.value, 10) || 0) + delta);
  input.value = newVal;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
